import React from 'react';
import {
  Accordions,
  AccordionsItem,
  AccordionsItemHeader,
  AccordionsItemSection,
  Banner,
  Flashy,
  Gutter,
} from '@axiom/ui';

import { OppFeedAccordionData } from './SupportContactsModal.const';

export const SupportContactsModalOppFeedQuestion = () => {
  return (
    <div data-test="SUPPORT_CONTACTS_OPP_FEED_QUESTION">
      <Banner type="info" impact="low">
        <Flashy bold>Because of the volume of Expressions of Interest</Flashy>,
        our team can't provide individual status updates or confirm receipt of
        specific EOIs.
      </Banner>
      <Gutter bottom="16px" />
      <Accordions name="OPP_FEED_ACCORDIONS">
        {OppFeedAccordionData.map((data, index) => {
          return (
            <AccordionsItem
              key={data.label}
              name={`OPP_FEED_ACCORDION_ITEM_${index}`}
            >
              <AccordionsItemHeader name={`OPP_FEED_ACCORDION_HEADER_${index}`}>
                {data.label}
              </AccordionsItemHeader>
              <AccordionsItemSection
                name={`OPP_FEED_ACCORDION_SECTION_${index}`}
              >
                <Gutter bottom="24px" />
                {data.desc}
              </AccordionsItemSection>
            </AccordionsItem>
          );
        })}
      </Accordions>
    </div>
  );
};
